// functions
import clean from './clean';
import clone from './clone';
import deepEqual from './deepEqual';
import deflate from './deflate';
import del from './del';
import each from './each';
import empty from './empty';
import every from './every';
import equal from './equal';
import filter from './filter';
import find from './find';
import flip from './flip';
import get from './get';
import has from './has';
import includes from './includes';
import inflate from './inflate';
import is from './is';
import keyOf from './keyOf';
import keys from './keys';
import map from './map';
import merge from './merge';
import set from './set';
import size from './size';
import slice from './slice';
import some from './some';
import sort from './sort';
import values from './values';

export {
  clean,
  clone,
  deepEqual,
  deflate,
  del,
  each,
  empty,
  equal,
  every,
  filter,
  find,
  flip,
  get,
  has,
  includes,
  inflate,
  is,
  keyOf,
  keys,
  map,
  merge,
  set,
  size,
  slice,
  some,
  sort,
  values,
};

export default {
  clean,
  clone,
  deepEqual,
  deflate,
  del,
  each,
  empty,
  equal,
  every,
  filter,
  find,
  flip,
  get,
  has,
  includes,
  inflate,
  is,
  keyOf,
  keys,
  map,
  merge,
  set,
  size,
  slice,
  some,
  sort,
  values,
};
